<template>
  <section>
    <pageHeader>DOCUMENT MANAGEMENT & ASSEMBLY</pageHeader>
    <UnderLinedHeader class="pt-15 pb-8 white"
      >Automated & Optimized</UnderLinedHeader
    >
    <v-row align="center" class="pt-0 pb-16 pr-16 pl-16">
      <p class="artice-text text-center">
        3545 can train your staff on the effective use of Document Management
        and Assembly products. The key is automating your processes in a way
        that makes sense for you. Document Assembly software and processes can
        optimize the creation of the documents you need to deliver. Document
        Management tools help you organize, store, and retrieve it efficiently.
        Let our team of specialists help you streamline your document production
        and retrieval.
      </p>
    </v-row>
    <v-row style="justify-content: space-around">
      <v-col
        align="center"
        cols="12"
        s="12"
        xs="12"
        lg="4"
        xl="4"
        md="6"
        v-for="(item, index) in softwares_details"
        :key="index"
      >
        <FlipCard >
        <template v-slot:front>
         
             <imageCard :imageName="item.imageName" :alt="item.imageName" parentFolder="Softwares"> </imageCard>
           
        </template>
        <template v-slot:back >
            <div  class="card_text_style" v-html="item.content"></div>
             <v-btn color="#ebebeb">
                <a
                  v-bind:href="item.url"
                  target="_blank"
                  style="text-decoration: none"
                  ><span style="color: #666">Learn More</span></a
                >
              </v-btn>
        </template>
      </FlipCard>
      </v-col>
    </v-row>
    <CaseStudy
      :text="item.text"
      :link="item.link"
      :color="item.color"
      :caseStudyText="item.caseStudyText"
      :say="item.say"
      :dashedSay="item.dashedSay"
      v-for="(item, index) in articles"
      :key="index"
      :class="item.class"
    >
      <template v-slot:header>
        <underLinedHeader class="pt-0 pb-6" :class="item.color">
          {{ item.title }}</underLinedHeader
        >
      </template>
      <template v-slot:image>
        <v-img
          contain
          :height="imgSize"
          :src="require('@/assets/imgs/Softwares/' + item.imgName)"
          :lazy-src="require('@/assets/imgs/Softwares/' + item.imgName)"
        >
        </v-img>
      </template>
    </CaseStudy>
    
  </section>
</template>

<script>
import ImgesMixin from "@/components/global/mixins/ImgesMixin.js";
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
import FlipCard from "@/components/global/compnentsMixins/FlipCard.vue";
import ImageCard from "@/components/global/ImageCard.vue";
import CaseStudy from "@/components/global/compnentsMixins/CaseStudy.vue";
export default {
  mixins: [ImgesMixin],
  components: { PageHeader, UnderLinedHeader, FlipCard,ImageCard,CaseStudy },
  data() {
    return {
      softwares_details: [
        {
          imageName: 'autonomy.png',
          content:
            "Using Autonomy WorkSite, the award-winning document and email management solution, you can manage all of your business documents and email intelligently from anywhere. We make information accessible from desktops, laptops, the internet, and mobile devices.",
          url: "https://imanage.com/",
        },
        {
          imageName: 'dragon.png',
          content:
            "Get more done faster by voice with Dragon, the world’s best-selling speech recognition software. It turns your talk into text and can make virtually any computer task easier and faster, helping you become more productive than ever before.",
          url: "https://www.nuance.com/dragon.html",
        },
        {
          imageName: 'dropbox.png',
          content:
            "Dropbox is a creative collaboration space designed to reduce busywork, bring your files together in one central place, and safely sync them across all your devices—so you can access them anytime, anywhere. And sending large files is easy, even to people who don’t have a Dropbox account.",
          url: "https://www.dropbox.com/",
        },
        {
          imageName: 'box.png',
          content:
            "With Box, all your team’s files are stored in the cloud so everyone on the team can access, edit, comment and share any of the files in real time from any device.",
          url: "https://www.box.com/",
        },
        {
          imageName: 'hotdocs.png',
          content:
            "HotDocs allows you to transform your frequently used documents and forms into intelligent templates that enable superfast production of custom documentation.",
          url: "https://www.hotdocs.com/",
        },
        {
          imageName: 'actionstep.png',
          content:
            "Actionstep is a powerful cloud-based legal practice & case management software with everything you need to run your entire law firm.",
          url: "https://www.actionstep.com/us/",
        },
        {
          imageName: 'msoffice.png',
          content:
            "We want you to do your best work – anywhere, anytime and with anyone. We specialize in SQL and Access but support the full Office suite. Whether it’s downloading, upgrading, or troubleshooting, our techs have got you covered!",
          url: "https://www.office.com/",
        },
        {
          imageName: 'msNET.png',
          content:
            "Microsoft .NET is a developer platform for building all your apps. Build for web, mobile, gaming, IoT, desktop, cloud and microservices.",
          url: "https://www.microsoft.com/net/",
        },
        {
          imageName: 'netdocs.png',
          content:
            "NetDocuments is a cloud-based document and email management service that provides enterprise-level security, mobility, disaster recovery, and collaboration solutions for organizations with high data security requirements, such as law firms, financial institutions, and insurance industries",
          url: "http://3545consulting-5825854.hs-sites.com/company/our-partners/netdocuments",
        },
        {
          imageName: 'worldox.png',
          content:
            "Easy to use cloud-based document & email management software. Proven in over 6000 organizations, Worldox is the best way find & use your information.",
          url: "https://www.worldox.com/",
        },
        {
          imageName: 'symphony.png',
          content:
            "Symphony Suite runs in the background to automatically OCR every file within your Worldox repository.",
          url: "https://accellis.com/partner/symphony-suite/",
        },
      ],
      articles: [
        {
          title: "Silverman Thompson Slutkin & White, LLC",
          text: "More and more law firms are discovering that their office server-based technologies can no longer adequately support a range of operational functions from case management to timekeeping & billing to accounting and document management. At the same time, doing the needed complete technology overhaul may seem like a daunting task and many firms may not know where to begin or which criteria are most important in deciding on the next technology to choose and implement. The law firm of Silverman Thompson Slutkin & White found themselves in just that position. Read how the firm quickly learned that the quality of their technology implementation provider was just as important as the quality of the technology platform they were implementing and how these two teams seamlessly worked together to execute a uniquely integrated cloud solution via an innovative tech partnership that was also uniquely customized for Silverman Thompson’s practice areas.",
          imgName: "Silverman-Case-Study-600px.png",
          link: "https://f.hubspotusercontent00.net/hubfs/5825854/Client%20Success%20Stories/Case%20Brief%20Study%20SIlverman%20Thompson%20Final%20-%20ST%20Aug.%2021.pdf",
          caseStudyText: `Read the Silverman Thompson Slutkin & White, LLC Case Study and learn more about how our team can solve for the unknown in nearly any situation.`,
          say: `“3545 Consulting provided a major value-added service to the entire process. In terms of converting our data, providing training to our staff, and working with Zola Suite to customize a solution for us, 3545 Consulting hit the mark on all of these.” `,
          dashedSay: `— Andrew Slutkin, Senior Partner, Silverman Thompson Slutkin & White`,
          class: "greyBG",
          color: "#f8f9f9",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
h5,
h6 { 
  font-family: $headerFontFamily;
}
p.artice-text {
  font-family: $primaryFontFamily;
  font-size: 1em;
}

.flip-card {
  background-color: transparent;
  width: 355px;
  height: 255px;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  /*box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);*/
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background-color: rgb(255, 255, 255);
  color: black;
}

.flip-card-back {
  background-color: #ffffff;
  color: rgb(0, 0, 0);
  transform: rotateY(180deg);
}
.card_text_style {
  margin: auto;
  padding: 20px;
}
</style>